var option = 'option_option__oqbb3n0';
var optionClickable = 'option_optionClickable__oqbb3n1';
var optionContent = 'option_optionContent__oqbb3n2';
var optionDescription = 'option_optionDescription__oqbb3n5';
var optionTitle = 'option_optionTitle__oqbb3n3';
var optionTitleText = 'option_optionTitleText__oqbb3n4';

export { option, optionClickable, optionContent, optionDescription, optionTitle, optionTitleText };
//# sourceMappingURL=option.vanilla.mjs.map
